module.exports = __webpack_public_path__ + "img/Pattern06.8dc8484c.png";